import { reviews } from "@/mocks/kakobuy-data";

export default function ReviewsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-2">
            Community Reviews
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            What Our <span className="text-primary-500">Community</span> Says
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {reviews.map((review, idx) => (
            <div
              key={review.handle}
              className="break-inside-avoid mb-4 md:mb-5 rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-700">{review.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                  <div className="text-xs text-foreground-500">{review.handle}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{review.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}